export default {"src":"/_next/static/media/blue-lake-logo.3b719e28.svg","height":89,"width":90,"blurWidth":0,"blurHeight":0};